// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'building-3-solid';

export const Component = () => (
  <g
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='1.5'
  >
    <path d='M4 4h17v20H4zm17 0H4l1.581-3h13.936zM1 24h23' />
    <path
      fill='currentColor'
      stroke='none'
      d='M21 4v20h-6.2v.2H10V24h4.8v-2.1c0-.6-.2-1.2-.7-1.7-.4-.4-1-.7-1.7-.7-.6 0-1.2.2-1.7.7-.4.4-.7 1-.7 1.7V24H4V4zM7.8 15.6c-.4 0-.8.4-.8.8s.4.8.8.8.8-.4.8-.8-.4-.8-.8-.8zm4.7 0c-.4 0-.8.4-.8.8s.4.8.8.8.8-.4.8-.8-.4-.8-.8-.8zm4.7 0c-.4 0-.8.4-.8.8s.4.8.8.8.8-.4.8-.8-.4-.8-.8-.8zm-9.4-4.7c-.4 0-.8.4-.8.8s.4.8.8.8.8-.4.8-.8-.4-.8-.8-.8zm4.7 0c-.4 0-.8.4-.8.8s.4.8.8.8.8-.4.8-.8-.4-.8-.8-.8zm4.7 0c-.4 0-.8.4-.8.8s.4.8.8.8.8-.4.8-.8-.4-.8-.8-.8zM7.8 6.2c-.4 0-.8.4-.8.8s.4.8.8.8.8-.4.8-.8-.4-.8-.8-.8zm4.7 0c-.4 0-.8.4-.8.8s.4.8.8.8.8-.4.8-.8-.4-.8-.8-.8zm4.7 0c-.4 0-.8.4-.8.8s.4.8.8.8.8-.4.8-.8-.4-.8-.8-.8z'
    />
  </g>
);

export const viewBox = '0 0 25 25';
